import React, { useRef, useState } from 'react';
import styles from './styles';
import { Carousel } from 'react-responsive-carousel';

const UltralabStep = ({ block }) => {
  if (!block) return '';
  const { items } = block;

  return (
    <>
      <div className="step-container">
        {items.map((item, i) => (
          <div className="card">
            <img
              className="image"
              src={item.image?.url}
              alt={item.image?.alt ? item.image?.alt : 'Image'}
            />

            <div className="description-section">
              <h1 className="title">
                STEP 0{`${i + 1}: `}
                {item.title1}
              </h1>

              <div className="description-container">
                <p className="description">{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mobile-step-carousel">
        <Carousel
          showStatus={false}
          showThumbs={false}
          showArrows={false}
          infiniteLoop
          preventMovementUntilSwipeScrollTolerance={true}
          swipeScrollTolerance={60}
          autoPlay={false}
        >
          {items.map((item, i) => (
            <div className="mobile-card-section ">
              <div className="mobile-card">
                <img
                  className="mobile-image"
                  src={item.image?.url}
                  alt={item.image?.alt ? item.image?.alt : 'Image'}
                />

                <div className="description-section">
                  <h1 className="title">
                    STEP 0{`${i + 1}: `}
                    {item.title1}
                  </h1>

                  <div className="description-container">
                    <p className="description">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      <style jsx>{styles}</style>
    </>
  );
};

export default UltralabStep;
